module.exports = __webpack_public_path__ + "assets/img/banner2.1b2def4c.png";